import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, retry } from 'rxjs';

import { environment } from '@kr/environment';
import { Transaction } from '@kr/models';
import { OrganizationService } from '@kr/services';

import { ChunkEstimatesAndRiskScoreReq, DownloadCsvReq, MassPayOut } from '../models';
import { MassPayOutApi } from './mass-pay-out-api.interface';

interface DownloadFileConfig {
  api: string;
  translationKey: string;
}

export const DOWNLOAD_CSV_CONFIG: DownloadFileConfig = {
  api: `/transactions/download-rows/`,
  translationKey: `massPayOutDetails.btn.saveAsCsv`,
};

@Injectable({ providedIn: 'root' })
export class MassPayOutApiService implements MassPayOutApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;
  readonly #organizationService = inject(OrganizationService);

  getEstimatesAndRiskScores(body: ChunkEstimatesAndRiskScoreReq, wallet_id: string, orgId: number): Observable<MassPayOut> {
    const api = `${this.#apiHost}/transactions/payout/mass/chunks/estimates-and-risk-scores/${wallet_id}`;

    return this.#http
      .post<MassPayOut>(api, body, {
        headers: this.#organizationService.getHttpHeaders(orgId),
      })
      .pipe(retry(1));
  }

  executeMassPayout(body: MassPayOut, wallet_id: string, orgId: number): Observable<Transaction[]> {
    const api = `${this.#apiHost}/transactions/payout/mass/${wallet_id}`;

    return this.#http.post<Transaction[]>(api, body, {
      headers: this.#organizationService.getHttpHeaders(orgId),
    });
  }

  downloadCsv(params: DownloadCsvReq, orgId: number): Observable<HttpResponse<Blob>> {
    return this.#http.post<Blob>(`${this.#apiHost}${DOWNLOAD_CSV_CONFIG.api}`, params, {
      responseType: 'blob' as 'json',
      observe: 'response',
      headers: this.#organizationService.getHttpHeaders(orgId),
    });
  }
}
